import { useReveal } from "../lib/useReveal";
import { ArrowRight, Apple, Play } from "lucide-react";

// Final CTA — matches soberfriend.io's dark gradient CTA exactly
export default function FinalCTA() {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            id="contact"
            data-testid="final-cta-section"
            className="py-20 md:py-24 bg-background"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white px-8 py-14 md:px-14 md:py-20 text-center shadow-2xl reveal">
                    <div
                        className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_top,_#10b981_0%,_transparent_50%)]"
                        aria-hidden="true"
                    />
                    <div className="relative z-10">
                        <div id="download" className="scroll-mt-28">
                            <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight tracking-tight">
                                Ready to put Hope in someone&apos;s pocket?
                            </h2>
                            <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
                                Genesis Recovery AI is built to feel polished, trustworthy, and deeply
                                supportive. Invite visitors to download the app, explore the directory, and
                                begin recovery with privacy and dignity.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                                <a
                                    href="#contact"
                                    data-testid="final-cta-start-button"
                                    className="inline-flex items-center justify-center whitespace-nowrap rounded-full transition-colors bg-white text-slate-900 hover:bg-white/90 h-14 px-8 text-base font-semibold shadow-xl gap-3"
                                >
                                    <Apple className="h-5 w-5" />
                                    App Store
                                    <ArrowRight className="h-5 w-5" />
                                </a>
                                <a
                                    href="#contact"
                                    data-testid="final-cta-demo-button"
                                    className="inline-flex items-center justify-center whitespace-nowrap border rounded-full border-white/30 bg-white/5 backdrop-blur-sm text-white hover:bg-white/10 h-14 px-8 text-base font-semibold transition-colors gap-3"
                                >
                                    <Play className="h-5 w-5 fill-current" />
                                    Google Play
                                </a>
                                <a
                                    href="/directory"
                                    data-testid="final-cta-directory-button"
                                    className="inline-flex items-center justify-center whitespace-nowrap border rounded-full border-white/20 bg-transparent text-white hover:bg-white/5 h-14 px-8 text-base font-semibold transition-colors gap-3"
                                >
                                    Browse Directory
                                </a>
                            </div>
                        </div>
                        <p id="crisis" className="text-xs text-white/50 mt-8">
                            Genesis Recovery AI is here to support reflection, privacy, and steady
                            progress on your recovery journey.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
